export default {"src":"/_next/static/media/passport.b58aa129.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};